import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Client, PaymentCard, PaymentHisotryItem, PaymentInfo, User } from '../clients.models';
import { PaymentCardDetailsDialog } from './dialogs/payment-card-details-dialog/payment-card-details-dialog';
import { PricelistPreview } from '../../pricelists/pricelists.models';
import { BoolToImgPipe, DictionaryPipe } from '../../_infrastructure/pipes';
import { AsyncPipe, DatePipe } from '@angular/common';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatCell, MatCellDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Subject } from 'rxjs';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { BlockClientDialog } from './dialogs/block-client-dialog/block-client-dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { env } from '../../../env/env';
import { OnlyNumbersDirective } from '../../_infrastructure/only-numbers-directive';
import { PaymentHistoryDetailsDialog } from './dialogs/payment-history-details-dialog/payment-history-details-dialog';
import { CurrentBillingReportDialog } from './dialogs/current-billing-report-dialog/current-billing-report-dialog';
import { SettlementDialog } from './dialogs/settlement-dialog/settlement-dialog';
import { ChangeBillingPeriodDialog } from './dialogs/change-billing-period-dialog/change-billing-period-dialog';
import { PricelistDetailsDialog } from './dialogs/pricelist-details-dialog/pricelist-details-dialog';
import { PricelistFormDialog } from './dialogs/pricelist-form-dialog/pricelist-form-dialog';
import { RolePermissionDirective } from '../../_infrastructure/directives/role-permission.directive';


@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.css'],
  imports: [
    MatTab,
    MatTabGroup,
    MatTableModule,
    MatRow,
    MatHeaderRow,
    MatHeaderCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatCellDef,
    MatHeaderCellDef,
    MatCell,
    MatHeaderCell,
    MatMenu,
    MatMenuModule,
    MatIconModule,
    BoolToImgPipe,
    DatePipe,
    DictionaryPipe,
    AsyncPipe,
    OnlyNumbersDirective,
    RolePermissionDirective
  ]
})
export class ClientDetailsComponent implements OnInit, AfterViewInit {

  constructor(public httpClient: HttpClient, private route: ActivatedRoute, private cd: ChangeDetectorRef) { }

  readonly dialog = inject(MatDialog);
  readonly snackBar = inject(MatSnackBar);
  public client: Client = new Client;
  public clientLoaded: Subject<boolean> = new Subject;
  public paymentHistory: MatTableDataSource<PaymentHisotryItem> = new MatTableDataSource<PaymentHisotryItem>;
  public paymentInfo: PaymentInfo | null = null;
  public users: MatTableDataSource<User> = new MatTableDataSource<User>;
  public pricelists: MatTableDataSource<PricelistPreview> = new MatTableDataSource<PricelistPreview>;
  public cennikiContainerHeight: string = '0px';
  public paymentHistoryHeight: string = '0px';
  @ViewChild('cennikiPageRef') cennikiPageRef?: ElementRef<HTMLDivElement>;
  @ViewChild('paymentHistoryRef') paymentHistoryRef?: ElementRef<HTMLDivElement>;

  public paymentCard: PaymentCard | null = null;

  public get cardBrand(): 'visa' | 'mastercard' | null {
    const type = this.paymentCard?.type?.toLowerCase() ?? '';
    if (type.includes('visa')) return 'visa';
    if (type.includes('master')) return 'mastercard';
    return null;
  }
  private tabActions: Record<number, () => void> = {
    0: this.loadPaymentTab,
    1: this.loadUsers,
    2: this.loadPricelists
  };

  //todo: move to global dictionaries
  public countries = [
    { 'PL': 'Polska' }
  ];

  public paymentStatuses = [
    { 1: 'Nieopłacono' },
    { 2: 'Opłacono' }
  ];

  ngOnInit() {
    this.loadClient();
    this.loadPaymentTab();
  }

  ngAfterViewInit() {
    window.addEventListener('resize', () => this.updateCennikiContainerHeight());
  }

  private updateCennikiContainerHeight() {
    if (this.cennikiPageRef) {
      const top = this.cennikiPageRef.nativeElement.getBoundingClientRect().top;
      this.cennikiContainerHeight = `calc(100vh - ${top}px - 10px)`;
    }
    if (this.paymentHistoryRef) {
      const top = this.paymentHistoryRef.nativeElement.getBoundingClientRect().top;
      this.paymentHistoryHeight = `calc(100vh - ${top}px - 10px)`;
    }
    this.cd.detectChanges();
  }

  private getClientId() {
    let id = this.route.snapshot.params['id'];
    return id;
  }


  private loadClient() {
    this.httpClient.get(`${env.apiUrl}/clients/${this.getClientId()}`).subscribe({
      next: s => {
        this.clientLoaded.next(true);
        this.client = s as Client;
      }
    });
  }

  private loadPaymentInfo() {
    this.httpClient.get(`${env.apiUrl}/clients/${this.getClientId()}/payment`).subscribe({
      next: s => {
        this.paymentInfo = s as PaymentInfo;
        this.cd.detectChanges();
      }
    })
  }

  private loadPaymentCard() {
    this.httpClient.get<PaymentCard | null>(`${env.apiUrl}/clients/${this.getClientId()}/payment/card`).subscribe({
      next: card => {
        this.paymentCard = card;
        this.cd.detectChanges();
      },
      error: () => {
        this.paymentCard = null;
        this.cd.detectChanges();
      }
    });
  }

  public showCardDetails() {
    if (!this.paymentCard) return;
    this.dialog.open(PaymentCardDetailsDialog, {
      width: '800px',
      maxWidth: 'none',
      data: { card: this.paymentCard }
    });
  }

  private loadPaymentHistory() {
    this.httpClient.get(`${env.apiUrl}/clients/${this.getClientId()}/payment/history`).subscribe({
      next: s => {
        const items = s as PaymentHisotryItem[];
        this.paymentHistory.data = items.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
      }
    });
  }

  private loadUsers() {
    this.httpClient.get(`${env.apiUrl}/clients/${this.getClientId()}/users`).subscribe({
      next: s => {
        this.users.data = (s as User[]);
      }
    });
  }

  private loadPricelists() {
    this.httpClient.get(`${env.apiUrl}/clients/${this.getClientId()}/pricelists`).subscribe({
      next: s => {
        this.pricelists.data = s as PricelistPreview[];
      }
    });
  }

  public onTabAnimationDone(): void {
    this.updateCennikiContainerHeight();
  }

  public selectPricelist(pricelist: PricelistPreview): void {
    const dialogRef = this.dialog.open(PricelistDetailsDialog, {
      width: '1300px',
      maxWidth: 'none',
      data: { clientId: this.getClientId(), pricelistId: pricelist.id }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'edit') {
        this.openEditPricelistDialog(pricelist.id);
      } else if (result) {
        this.loadPricelists();
      }
    });
  }

  public openCreatePricelistDialog(): void {
    const dialogRef = this.dialog.open(PricelistFormDialog, {
      width: '1300px',
      maxWidth: 'none',
      height: 'auto',
      maxHeight: 'none',
      data: { clientId: this.getClientId() }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.loadPricelists();
    });
  }

  private openEditPricelistDialog(pricelistId: string): void {
    const dialogRef = this.dialog.open(PricelistFormDialog, {
      width: '1300px',
      maxWidth: 'none',
      height: 'auto',
      maxHeight: 'none',
      data: { clientId: this.getClientId(), pricelistId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.loadPricelists();
    });
  }

  public loginAsUser(userId: string) {
    this.httpClient.get(`${env.apiUrl}/users/${userId}/login`).subscribe(
      (s: any) => {
        window.open(s.url, '_blank');
      }
    );
  }

  public unblockClient() {
    this.httpClient.post(`${env.apiUrl}/clients/${this.getClientId()}/unblock`, null).subscribe({
      next: _ => this.loadPaymentInfo()
    })
  }

  public blockClient() {
    const dialogRef = this.dialog.open(BlockClientDialog, {
      data: { clientId: this.getClientId() }
    });
    dialogRef.afterClosed().subscribe(
      _ => this.loadPaymentInfo()
    )
  }

  public deactivateClient() {
    this.httpClient.post(`${env.apiUrl}/clients/${this.getClientId()}/deactivate`, null).subscribe({
      next: _ => {
        this.snackBar.open('Klient został dezaktywowany', 'OK', { duration: 5000, horizontalPosition: 'right', verticalPosition: 'bottom' });
        this.loadPaymentInfo();
      }
    });
  }

  public deleteClient() {
    const confirmed = window.confirm('Operacja jest nieodwracalna. Kontynuować?');
    if (!confirmed) return;
    this.httpClient.post(`${env.apiUrl}/clients/${this.getClientId()}/deletion`, null).subscribe({
      next: _ => this.snackBar.open(
        'Pomyślnie dodano klienta do kolejki do usunięcia. Klient zostanie usunięty w ciągu 24h',
        'OK',
        { duration: 5000, horizontalPosition: 'right', verticalPosition: 'bottom' }
      )
    });
  }

  public showCurrentBillingReport() {
    let _ = this.dialog.open(CurrentBillingReportDialog, { width: '1200px', maxWidth: 'none',
      data: { clientId: this.getClientId() }
    });
  }

  public showSettlementDialog() {
    let _ = this.dialog.open(SettlementDialog, {
      width: '1037px',
      data: { clientId: this.getClientId(), billingPeriodFrom: this.paymentInfo?.billingPeriod?.from ?? null }
    });
  }

  public showChangeBillingPeriodDialog() {
    const dialogRef = this.dialog.open(ChangeBillingPeriodDialog, {
      width: '520px',
      data: { clientId: this.getClientId(), billingPeriod: this.paymentInfo?.billingPeriod }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.loadPaymentInfo();
    });
  }

  public showDetails(item: PaymentHisotryItem ) {
    let _ = this.dialog.open(PaymentHistoryDetailsDialog, { height: '500px', width: '1200px', maxWidth: 'none',
      data: { clientId: this.getClientId(), item }
    });
  }

  public downloadInvoicePdf(item: PaymentHisotryItem) {
    this.httpClient.get(`${env.apiUrl}/clients/${this.getClientId()}/payment/invoices/${item.invoiceId}/pdf`, {
      responseType: 'blob',
      observe: 'response'
    }).subscribe({
      next: s => {
        const blob = s.body as Blob;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = item.invoiceNumber + '.pdf';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    })
    //window.open(`${env.apiUrl}/clients/${this.getClientId()}/payment/invoices/${invoiceId}/pdf`, '_blank');
  }

  private loadPaymentTab(): void {
    this.loadPaymentInfo();
    this.loadPaymentCard();
    this.loadPaymentHistory();
  }

  public acceptPayment(item: PaymentHisotryItem) {
    this.httpClient.post(`${env.apiUrl}/clients/${this.getClientId()}/payment/history/${item.id}/accept`, {}).subscribe({
      next: _ => {
        const index = this.paymentHistory.data.indexOf(item);
        const updatedItem = { ...item, accepted: true };
        this.paymentHistory.data[index] = updatedItem;
        this.paymentHistory.data = [...this.paymentHistory.data];
        this.cd.detectChanges();
      },
      error: e => {
        console.log(e);
      }
    })
  }

  public tabChanged($e: any): void {
    let tabIndex = $e.index as number;
    let action = this.tabActions[tabIndex];
    action.call(this);
  }
}
